import React from 'react';
import { KEYBOARD_KEYS } from '../../../constants';
import { RadioInput, RadioLabel } from './RadioButton.styles';
import { RadioButtonProps, RadioState, Status } from './types';

const RadioButton = ({
  label,
  value,
  onValueChange,
  isSelected,
  isDisabled,
  ...rest
}: RadioButtonProps) => {
  const state = `${isSelected ? 'selected' : 'unselected'}`;
  const status = `${isDisabled ? 'disabled' : 'active'}` as Status;
  const variant = `${state}-${status}` as RadioState;

  const handleChange = () => {
    !isDisabled && onValueChange(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.code === KEYBOARD_KEYS.SPACE) {
      handleChange();
    }
  };

  return (
    <RadioLabel
      htmlFor={`${value}`}
      labelVariant={status}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      data-testid="radio-label"
    >
      <RadioInput
        type="radio"
        tabIndex={-1}
        value={value}
        onChange={handleChange}
        checked={isSelected}
        variant={variant}
        id={`${value}`}
        {...rest}
      />
      {label}
    </RadioLabel>
  );
};
export default RadioButton;
